import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const testimonials = [{
  name: 'Mirta R.',
  role: 'Jubilada · Mendoza',
  emoji: '👩',
  quote: 'En dos semanas ya tenía mis primeros jabones. Los regalé en Navidad y todos me preguntaron dónde los compraba. <strong class="text-brand-brown">Tengo 58 años y nunca pensé que podía hacer algo así.</strong>'
}, {
  name: 'Graciela P.',
  role: 'Comerciante · Córdoba',
  emoji: '👩‍🦳',
  quote: 'Probé YouTube mil veces y siempre me salía mal. Con este Pack seguí las instrucciones y <strong class="text-brand-brown">el primer jabón me quedó perfecto.</strong> La lista de ingredientes exacta fue un cambio total.'
}, {
  name: 'Susana V.',
  role: '63 años · Buenos Aires',
  emoji: '🧑‍🦳',
  quote: '<strong class="text-brand-brown">Ya vendo en el mercado de mi barrio todos los sábados.</strong> El bonus de recetas me dio ideas para hacer jabones Premium que puedo cobrar el doble.'
}];
export function Testimonials() {
  return <section className="py-14 px-4 bg-brand-cream relative" data-id="element-244">
      <div className="max-w-7xl mx-auto" data-id="element-245">
        <div className="text-center mb-10" data-id="element-246">
          <h2 className="text-3xl md:text-5xl font-black mb-3 tracking-tight" data-id="element-247">
            Resultados reales
          </h2>
          <p className="text-xl text-brand-brown/80 font-playfair italic" data-id="element-248">
            Mujeres como vos que ya empezaron
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6 items-stretch mb-12" data-id="element-249">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-white rounded-2xl p-6 md:p-7 shadow-xl border border-brand-brown/5 relative flex flex-col pt-8" data-id="element-250">
              <div className="absolute top-3 right-3 bg-green-100 text-brand-dark-green text-[10px] font-bold px-2 py-1 rounded-full border border-green-200 uppercase tracking-wider" data-id="element-251">
                Resultado real ✓
              </div>

              <div className="absolute -top-5 -left-1 text-7xl text-brand-gold/20 font-playfair leading-none select-none" data-id="element-252">
                "
              </div>

              <div className="flex items-center gap-4 mb-5 relative z-10" data-id="element-253">
                <div className="w-14 h-14 bg-gradient-to-br from-brand-amber-light to-brand-gold/20 rounded-full flex items-center justify-center text-2xl shadow-inner border border-brand-gold/30" data-id="element-254">
                  {t.emoji}
                </div>
                <div data-id="element-255">
                  <div className="font-black text-lg" data-id="element-256">{t.name}</div>
                  <div className="text-xs font-bold text-brand-brown/50 uppercase tracking-wider mt-0.5" data-id="element-257">
                    {t.role}
                  </div>
                </div>
              </div>

              <div className="flex text-brand-gold mb-4 gap-0.5" data-id="element-258">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-259" />)}
              </div>

              <p className="text-brand-brown/80 text-[15px] leading-relaxed italic flex-grow" dangerouslySetInnerHTML={{
            __html: `"${t.quote}"`
          }} data-id="element-260" />
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-261">
          <CTAButton className="w-full md:w-auto md:px-10 text-xl py-4 shadow-[0_10px_30px_rgba(45,90,61,0.4)]" data-id="element-262">
            QUIERO RESULTADOS COMO ESTOS →
          </CTAButton>
        </div>
      </div>
    </section>;
}